import React, { useState } from 'react';
import { FaUpload, FaTrash, FaCoins, FaCalendarAlt, FaMoneyBillWave, FaBox, FaFire } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useAuth } from '../security/security/AuthContext';

const AddProduct = () => {
  const [images, setImages] = useState([]);
  const { userDetails } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    cycle: '',
    available: '',
    dailyIncome: '',
    totalIncome: '',
    price: '',
    productType: 'NORMAL',
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    if (images.length + files.length > 4) {
      toast.error('You can only upload up to 4 images.');
      return;
    }
    setImages([...images, ...files]);
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');

    if (!token) {
      toast.error('Authentication token is missing.');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('cycle', formData.cycle);
    formDataToSend.append('available', formData.available);
    formDataToSend.append('dailyIncome', formData.dailyIncome);
    formDataToSend.append('totalIncome', formData.totalIncome);
    formDataToSend.append('price', formData.price);
    formDataToSend.append('productType', formData.productType);
    
    images.forEach((image) => {
      formDataToSend.append('photos', image);
    });

    setLoading(true);

    try {
      const response = await axios.post('https://api.globallequityfinance.com/api/products/add', formDataToSend, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        toast.success('Product added successfully!');
        setFormData({
          name: '',
          cycle: '',
          available: '',
          dailyIncome: '',
          totalIncome: '',
          price: '',
          productType: 'NORMAL',
        });
        setImages([]);
      }
    } catch (error) {
      toast.error('Failed to add product. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="forex-pesa-admin-add-product-container">
      <div className="forex-pesa-admin-add-product-header">
        <div className="forex-pesa-admin-add-product-title-wrapper">
          <h1 className="forex-pesa-admin-add-product-title">Add New Product</h1>
          <p className="forex-pesa-admin-add-product-subtitle">Create a new investment product for your users</p>
        </div>
      </div>

      <div className="forex-pesa-admin-add-product-content">
        <form onSubmit={handleSubmit} className="forex-pesa-admin-add-product-form">
          <div className="forex-pesa-admin-add-product-form-section">
            <h2 className="forex-pesa-admin-add-product-section-title">Product Information</h2>
            
            <div className="forex-pesa-admin-add-product-form-grid">
              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="name">
                  <FaCoins className="forex-pesa-admin-add-product-input-icon" />
                  Product Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter product name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>

              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="cycle">
                  <FaCalendarAlt className="forex-pesa-admin-add-product-input-icon" />
                  Cycle (Days)
                </label>
                <input
                  type="number"
                  id="cycle"
                  name="cycle"
                  placeholder="Enter cycle in days"
                  value={formData.cycle}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>

              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="available">
                  <FaBox className="forex-pesa-admin-add-product-input-icon" />
                  Available Units
                </label>
                <input
                  type="number"
                  id="available"
                  name="available"
                  placeholder="Enter available units"
                  value={formData.available}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>

              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="productType">
                  <FaFire className="forex-pesa-admin-add-product-input-icon" />
                  Product Type
                </label>
                <select
                  id="productType"
                  name="productType"
                  value={formData.productType}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                >
                  <option value="NORMAL">Normal</option>
                  <option value="HOT">Hot</option>
                </select>
              </div>
            </div>
          </div>

          <div className="forex-pesa-admin-add-product-form-section">
            <h2 className="forex-pesa-admin-add-product-section-title">Profit Information</h2>
            
            <div className="forex-pesa-admin-add-product-form-grid">
              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="dailyIncome">
                  <FaMoneyBillWave className="forex-pesa-admin-add-product-input-icon" />
                  Daily Income (KES)
                </label>
                <input
                  type="number"
                  id="dailyIncome"
                  name="dailyIncome"
                  placeholder="Enter daily income amount"
                  value={formData.dailyIncome}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>

              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="totalIncome">
                  <FaMoneyBillWave className="forex-pesa-admin-add-product-input-icon" />
                  Total Income (KES)
                </label>
                <input
                  type="number"
                  id="totalIncome"
                  name="totalIncome"
                  placeholder="Enter total income amount"
                  value={formData.totalIncome}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>

              <div className="forex-pesa-admin-add-product-form-group">
                <label htmlFor="price">
                  <FaMoneyBillWave className="forex-pesa-admin-add-product-input-icon" />
                  Price (KES)
                </label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  placeholder="Enter product price"
                  value={formData.price}
                  onChange={handleInputChange}
                  required
                  className="forex-pesa-admin-add-product-input"
                />
              </div>
            </div>
          </div>

          <div className="forex-pesa-admin-add-product-form-section">
            <h2 className="forex-pesa-admin-add-product-section-title">Product Images</h2>
            <p className="forex-pesa-admin-add-product-section-desc">Upload up to 4 high-quality images of your product</p>
            
            <div className="forex-pesa-admin-add-product-image-upload-container">
              <label htmlFor="images" className="forex-pesa-admin-add-product-image-upload-label">
                <FaUpload className="forex-pesa-admin-add-product-upload-icon" />
                <span>Upload Images</span>
              </label>
              <input
                type="file"
                id="images"
                onChange={handleImageUpload}
                multiple
                accept="image/*"
                className="forex-pesa-admin-add-product-image-input"
              />
            </div>

            {images.length > 0 && (
              <div className="forex-pesa-admin-add-product-image-preview-container">
                {images.map((image, index) => (
                  <div key={index} className="forex-pesa-admin-add-product-image-preview-item">
                    <img src={URL.createObjectURL(image)} alt={`Preview ${index + 1}`} />
                    <button 
                      type="button" 
                      onClick={() => removeImage(index)} 
                      className="forex-pesa-admin-add-product-image-remove-btn"
                    >
                      <FaTrash />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="forex-pesa-admin-add-product-form-actions">
            <button 
              type="submit" 
              className="forex-pesa-admin-add-product-submit-btn" 
              disabled={loading}
            >
              {loading ? 'Adding Product...' : 'Add Product'}
              <span className="forex-pesa-admin-add-product-btn-shine"></span>
            </button>
          </div>
        </form>
      </div>

      <ToastContainer position="top-right" autoClose={5000} />

      <style jsx>{`
        /* Global Equity Admin Add Product Component Styles */
        .forex-pesa-admin-add-product-container {
          --primary-color: #2176FF;
          --primary-light: #6CA6FF;
          --primary-dark: #0D4CB3;
          --secondary-color: #33A1FD;
          --accent-color: #FFC107;
          --success-color: #4CAF50;
          --danger-color: #F44336;
          --dark-bg: #0A1128;
          --card-bg: #0F1C3F;
          --card-bg-lighter: #192952;
          --text-color: #F0F5FF;
          --text-muted: #B0C4DE;
          --border-color: rgba(82, 119, 204, 0.2);
          --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
          --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);
          --shadow-lg: 0 10px 20px rgba(0, 0, 0, 0.15);
          --radius-sm: 0.25rem;
          --radius-md: 0.5rem;
          --radius-lg: 1rem;
          
          width: 90%;
          background-color: var(--dark-bg);
          border-radius: var(--radius-lg);
          overflow: hidden;
          color: var(--text-color);
          box-shadow: var(--shadow-lg);
          margin-bottom: 2rem;
        }

        .forex-pesa-admin-add-product-header {
          background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
          padding: 2rem;
          position: relative;
          overflow: hidden;
        }

        .forex-pesa-admin-add-product-header::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
          opacity: 0.7;
          z-index: 1;
        }

        .forex-pesa-admin-add-product-title-wrapper {
          position: relative;
          z-index: 2;
        }

        .forex-pesa-admin-add-product-title {
          font-size: 1.875rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #ffffff;
          position: relative;
          display: inline-block;
        }

        .forex-pesa-admin-add-product-title::after {
          content: '';
          position: absolute;
          bottom: -0.5rem;
          left: 0;
          width: 80px;
          height: 4px;
          background: var(--accent-color);
          border-radius: 2px;
        }

        .forex-pesa-admin-add-product-subtitle {
          font-size: 1rem;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 1rem;
        }

        .forex-pesa-admin-add-product-content {
          padding: 2rem;
          background-color: var(--card-bg);
        }

        .forex-pesa-admin-add-product-form {
          display: flex;
          flex-direction: column;
          gap: 2.5rem;
        }

        .forex-pesa-admin-add-product-form-section {
          background-color: var(--card-bg-lighter);
          border-radius: var(--radius-md);
          padding: 1.5rem;
          box-shadow: var(--shadow-sm);
          border: 1px solid var(--border-color);
        }

        .forex-pesa-admin-add-product-section-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          color: var(--text-color);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .forex-pesa-admin-add-product-section-desc {
          font-size: 0.875rem;
          color: var(--text-muted);
          margin-bottom: 1.5rem;
        }

        .forex-pesa-admin-add-product-form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
        }

        .forex-pesa-admin-add-product-form-group {
          margin-bottom: 0.5rem;
        }

        .forex-pesa-admin-add-product-form-group label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 0.5rem;
          color: var(--text-muted);
        }

        .forex-pesa-admin-add-product-input-icon {
          color: var(--primary-light);
        }

        .forex-pesa-admin-add-product-input {
          width: 90%;
          padding: 0.75rem 1rem;
          font-size: 0.95rem;
          background-color: rgba(15, 28, 63, 0.8);
          border: 1px solid var(--border-color);
          color: var(--text-color);
          border-radius: var(--radius-md);
          transition: all 0.2s ease;
        }

        .forex-pesa-admin-add-product-input:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 2px rgba(33, 118, 255, 0.2);
        }

        .forex-pesa-admin-add-product-input::placeholder {
          color: rgba(176, 196, 222, 0.6);
        }

        .forex-pesa-admin-add-product-image-upload-container {
          margin-bottom: 1.5rem;
        }

        .forex-pesa-admin-add-product-image-upload-label {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem 1.5rem;
          background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
          color: white;
          border-radius: var(--radius-md);
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s ease;
          box-shadow: var(--shadow-sm);
        }

        .forex-pesa-admin-add-product-image-upload-label:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .forex-pesa-admin-add-product-upload-icon {
          font-size: 1rem;
        }

        .forex-pesa-admin-add-product-image-input {
          display: none;
        }

        .forex-pesa-admin-add-product-image-preview-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
          gap: 1rem;
          margin-top: 1.5rem;
        }

        .forex-pesa-admin-add-product-image-preview-item {
          position: relative;
          border-radius: var(--radius-md);
          overflow: hidden;
          aspect-ratio: 1/1;
          background-color: var(--card-bg);
          border: 1px solid var(--border-color);
          box-shadow: var(--shadow-sm);
        }

        .forex-pesa-admin-add-product-image-preview-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .forex-pesa-admin-add-product-image-remove-btn {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
          width: 2rem;
          height: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(244, 67, 54, 0.8);
          color: white;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .forex-pesa-admin-add-product-image-remove-btn:hover {
          background-color: var(--danger-color);
          transform: scale(1.1);
        }

        .forex-pesa-admin-add-product-form-actions {
          display: flex;
          justify-content: flex-end;
          margin-top: 1rem;
        }

        .forex-pesa-admin-add-product-submit-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.875rem 2.5rem;
          background: linear-gradient(135deg, var(--accent-color), #FF9800);
          color: #212121;
          font-weight: 600;
          font-size: 1rem;
          border: none;
          border-radius: var(--radius-md);
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: var(--shadow-md);
          overflow: hidden;
        }

        .forex-pesa-admin-add-product-submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow-lg);
        }

        .forex-pesa-admin-add-product-submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .forex-pesa-admin-add-product-btn-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg, 
            transparent, 
            rgba(255, 255, 255, 0.3), 
            transparent
          );
          animation: btn-shine 3s infinite;
        }

        @keyframes btn-shine {
          0% { left: -100%; }
          20% { left: 100%; }
          100% { left: 100%; }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .forex-pesa-admin-add-product-header {
            padding: 1.5rem;
          }
          
          .forex-pesa-admin-add-product-content {
            padding: 1.5rem;
          }
          
          .forex-pesa-admin-add-product-form-grid {
            grid-template-columns: 1fr;
          }
          
          .forex-pesa-admin-add-product-title {
            font-size: 1.5rem;
          }
          
          .forex-pesa-admin-add-product-section-title {
            font-size: 1.125rem;
          }
        }

        @media (max-width: 480px) {
          .forex-pesa-admin-add-product-header,
          .forex-pesa-admin-add-product-content {
            padding: 1rem;
          }
          
          .forex-pesa-admin-add-product-form-section {
            padding: 1rem;
          }
          
          .forex-pesa-admin-add-product-image-preview-container {
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          }
          
          .forex-pesa-admin-add-product-form-actions {
            justify-content: center;
          }
          
          .forex-pesa-admin-add-product-submit-btn {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default AddProduct;